// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { gtmEventPush } from 'utils/gtm/events';

// Styles
import styles from 'components/Checkbox.scss';

// Helpers
import classNames from 'classnames';

/**
 * <Checkbox /> component.
 */
class Checkbox extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {string} name - input name.
   * @prop {string} label - label
   * @prop {boolean} selectedValue - value
   * @prop {boolean} isLanding - isLanding
   */
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    selectedValue: PropTypes.bool,
    isLanding: PropTypes.bool,
    isDisabled: PropTypes.bool
  };

  handleChange = () => {
    gtmEventPush({
      method: 'filterForm',
      args: {
        itemLabel: this.props.label
      }
    });
  };

  /**
   * Renders <Checkbox /> component.
   *
   * @return {JSX} - renders an Input.
   */
  render() {
    const { name, label, selectedValue, isLanding, isDisabled } = this.props;

    return (
      <div>
        <label
          key={name}
          className={classNames(
            styles.container,
            isLanding ? styles.containerLanding : null,
            isDisabled ? styles.containerLandingDisabled : null
          )}
        >
          <span className={styles.containerLabel}>{label}</span>
          <Field
            name={name}
            value={selectedValue}
            component={'input'}
            type={'checkbox'}
            disabled={isDisabled}
            onChange={this.handleChange}
          />
          <span className={styles.checkmark} />
        </label>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/Common/Checkbox/index.js